import type { HumanName } from '@/types'

interface GetConfigProps {
  digitalProductId: string
}

export const icon: string = 'arrow-progress'
export const humanName: HumanName = {
  singular: 'Jornada',
  plural: 'Jornadas'
}
export const getConfig = (props: GetConfigProps) => {
  const { digitalProductId } = props
  const basePath = '/jornadas'
  const apiBasePath = `/user/digital_products/${digitalProductId}/journeys`

  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    pagination: {
      per_page: 999
    },
    sort: {
      field: 'position',
      order: 'asc'
    }
  }

  return config
}
